import { createContext, useContext } from 'react';
import { SidePanelType } from './types';

const PanelTypeContext = createContext<SidePanelType | null>(null);

export const PanelTypeProvider = PanelTypeContext.Provider;

export const usePanelType = (): SidePanelType | null => useContext(PanelTypeContext);
